<template>
  <div class="scroll-loader">
    <div class="scrool-loader-all ms-help" v-if="allDataLoaded">
      Все данные загружены
    </div>
    <inline-loader v-else :loading="true" />
  </div>
</template>

<script>
import InlineLoader from './inline-loader'

export default {
  props: {
    allDataLoaded: {
      type: Boolean,
      required: true
    }
  },
  components: {
    InlineLoader
  }
}
</script>

<style lang="less">
.scroll-loader {
  padding: 8px;
  text-align: center;
}
</style>
